// JoditEditorComponent.jsx
import React, { useRef, useEffect } from "react";
import JoditEditor from "jodit-react";

const JoditEditorComponent = ({ defaultValue = "", onChange, placeholder = "Enter text...", height = 300 }) => {
  const editor = useRef(null);

  return (
    <JoditEditor
      ref={editor}
      value={defaultValue}
      config={{
        readonly: false,
        height,
        placeholder,
        toolbarSticky: false,
        askBeforePasteHTML: false,
        askBeforePasteFromWord: false,
        allowPasteImages: true,
        disablePlugins: ["pasteStorage"],
      }}
      onBlur={(newContent) => {
        onChange(newContent);
      }}
    />
  );
};

export default JoditEditorComponent;
